import { GenericForm, GenericFormBGContainer } from "@/components/GenericForm";
import { Divider } from "@/components/misc";
import { InvoiceProps } from "@/interfaces/invoices_types";
import { Control } from "react-hook-form";
import { FieldErrors } from "react-hook-form";
import { UseFormRegister } from "react-hook-form";
import { InvoiceFormData } from "./InvoiceForm";
import { Input } from "@/components/_Shared/Form/Inputs/Input";
import { SelectContainer } from "@/components/_Shared/Form/Inputs/Select";
import { Checkbox } from "@/components/_Shared/Form/Inputs/Checkbox";
import { Submit } from "@/components/_Shared/Form/Buttons/Submit";
import { TextArea } from "@/components/_Shared/Form/Inputs/TextArea";
import { SliderWithInput } from "@/components/_Shared/Form/Inputs/Slider";
import { FormGroup } from "@/components/_Shared/Form/Containers/FormGroup";
import { FormFetchDataProps } from "@/components/_Shared/Form/Interfaces/FormFetchData";
import { SearchSelect } from "@/components/_Shared/Form/Inputs/SearchSelect";

type InvoiceFormBaseProps = {
    method: string
    currentInvoiceData?: InvoiceProps
    register: UseFormRegister<InvoiceFormData>
    errors: FieldErrors<InvoiceFormData>
    isSubmitting: boolean
    control: Control<InvoiceFormData>
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
    manager_list: FormFetchDataProps[]
}

export function InvoiceFormBase({ method, currentInvoiceData, register, errors, isSubmitting, control, onSubmit, manager_list }: InvoiceFormBaseProps) {
    return (
        <>
            <GenericForm form_id="invoice_form" onSubmit={onSubmit}>
                <GenericFormBGContainer>
                    <h2 className="text-2xl font-bold">{method === "POST" ? "Create" : "Update"} Invoice</h2>

                    <Divider />

                    {/* Invoice ID */}
                    <input type="hidden" value={currentInvoiceData?.invoice_id} {...register("invoice_id")} />
                    <input type="hidden" value={currentInvoiceData?.project_id} {...register("project_id")} />

                    <Input label="Project Name" name="project_name" type="text" register={register} defaultValue={currentInvoiceData?.project_name} readOnly={method === "PUT"} required/>
                    {errors.project_name && <p className="text-red-500">{errors.project_name.message}</p>}

                    <FormGroup>
                        <Input label="Invoice Date" name="invoice_date" type="date" register={register} defaultValue={currentInvoiceData?.invoice_date} required/>
                        <SelectContainer name="payment_status" options={["Sent", "Pending"]} placeholder="Payment Status" control={control} required defaultValue={currentInvoiceData?.payment_status}/>
                        {errors.payment_status && <p className="text-red-500">{errors.payment_status.message}</p>}
                    </FormGroup>

                    <TextArea name="notes" label="Notes" placeholder="Write notes here..." register={register} />
                    {errors.notes && <p className="text-red-500">{errors.notes.message}</p>}

                    <SearchSelect label="Sent By" name="user_sent_by_name" options={manager_list} control={control} />
                    {errors.user_sent_by_name && <p className="text-red-500">{errors.user_sent_by_name.message}</p>}
                    
                    <SliderWithInput label="Payment Amount" required control={control} name="payment_amount" defaultValue={currentInvoiceData?.payment_amount ?? 0} max={100} min={0} step={1} />
                    {errors.payment_amount && <p className="text-red-500">{errors.payment_amount.message}</p>}
                    
                    <Checkbox name="is_sent_to_quickbooks" label="Sent to Quickbooks" register={register} defaultValue={currentInvoiceData?.is_sent_to_quickbooks ?? false} />

                    <Submit isSubmitting={isSubmitting} label={method === "POST" ? "Create Invoice" : "Update Invoice"} />
                </GenericFormBGContainer>
            </GenericForm>

        </>
    );
}
